module.exports = {"230304001":"东兴街道","230304002":"矿里街道","230304003":"洗煤街道","230304004":"大通沟街道","230304200":"滴道河乡","230304201":"兰岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230304.json
// module id = 797
// module chunks = 0